module.exports = __webpack_public_path__ + "img/placeholder.a553c358.png";